import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { createPersistentStorage } from '../../../lib/persistentStorage'
import type { SegmentId } from '../../product-segment'
import type { OnboardingPayload } from './types'

export type OnboardingVariant = 'default' | 'quiz'
export const useOnboardingVariant = create<{ variant: OnboardingVariant }>()(
  persist<{ variant: OnboardingVariant }>(() => ({ variant: 'default' }), { name: 'humanteq-onboarding-variant', storage: createPersistentStorage() }),
)
export function clearOnboardingVariant() { useOnboardingVariant.setState({ variant: 'default' }) }
export function captureOnboardingVariant(url: URL, segment: SegmentId) {
  if (segment !== 'break_up') { clearOnboardingVariant(); return }
  const values = url.searchParams.getAll('variant')
  if (values.length === 1 && (values[0] === 'quiz' || values[0] === 'default')) {
    useOnboardingVariant.setState({ variant: values[0] })
  }
}
export function draftVariant(answers: OnboardingPayload): OnboardingVariant {
  return answers.custom?.variant === 'quiz' ? 'quiz' : 'default'
}
